/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { contentFavoriteControllerToggleFavorite } from '../fn/content-favorite/content-favorite-controller-toggle-favorite';
import { ContentFavoriteControllerToggleFavorite$Params } from '../fn/content-favorite/content-favorite-controller-toggle-favorite';

@Injectable({ providedIn: 'root' })
export class ContentFavoriteService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `contentFavoriteControllerToggleFavorite()` */
  static readonly ContentFavoriteControllerToggleFavoritePath = '/api/content-favorite';

  /**
   * 콘텐츠 즐겨찾기 토글.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `contentFavoriteControllerToggleFavorite()` instead.
   *
   * This method doesn't expect any request body.
   */
  contentFavoriteControllerToggleFavorite$Response(params: ContentFavoriteControllerToggleFavorite$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
    return contentFavoriteControllerToggleFavorite(this.http, this.rootUrl, params, context);
  }

  /**
   * 콘텐츠 즐겨찾기 토글.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `contentFavoriteControllerToggleFavorite$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  contentFavoriteControllerToggleFavorite(params: ContentFavoriteControllerToggleFavorite$Params, context?: HttpContext): Observable<boolean> {
    return this.contentFavoriteControllerToggleFavorite$Response(params, context).pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

}
